export default "__VITE_ASSET__DKbb5QfK__"